class Tooltips {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-bs-toggle="tooltip"]'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.each((index, scope) => {
			new bootstrap.Tooltip(scope);
		})
	}
}

export default Tooltips;